import React from 'react';
import './ContactHeader.css';
import { useSelector } from 'react-redux';

const ContactHeader = ({place,address1,address2,vat}) => {

  const contactCopenhagen = useSelector((state) => state.ContactCopenhagen);
  const contactBillund = useSelector((state) => state.ContactBillund);
  return (
    <div className="contact-header">
      <h1 className="contact-title">Spirit Air Cargo - {place}</h1>
      <div className="contact-info-wrapper">
        <div className="visiting-address">
          <h3 className="address-title">{place=='COPENHAGEN' ? contactCopenhagen?.visitingAddressHeading : contactBillund?.visitingAddressHeading}</h3>
          <div className="address-details">            
            <p>{address1}</p>
          </div>
        </div>
        <div className="opening-hours">
          <h3 className="address-title">{place=='COPENHAGEN' ? contactCopenhagen?.openingHoursHeading : contactBillund ?.openingHoursHeading}</h3>
          <div className="hours-details">
            <p>{place=='COPENHAGEN' ? contactCopenhagen?.openingHoursWeekdays : contactBillund?.openingHoursWeekdays}</p>
            <p>{place=='COPENHAGEN' ? contactCopenhagen?.openingHoursWeekends : contactBillund?.openingHoursWeekends}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactHeader;
